import { render, staticRenderFns } from "./CreateGlobalContractStep.vue?vue&type=template&id=06d89dda"
import script from "./CreateGlobalContractStep.vue?vue&type=script&lang=js"
export * from "./CreateGlobalContractStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports